import { cn } from "@/lib/utils";

export function StampSerial({ value, className }) {
  if (!value) return <span className="text-slate/50 font-mono text-xs">—</span>;
  return (
    <span
      className={cn(
        "inline-flex items-center border border-brass text-brass bg-brass/5 font-mono px-2 py-0.5 rounded-sm text-xs font-bold tracking-wide",
        className
      )}
    >
      {value}
    </span>
  );
}

const STATUS_MAP = {
  active: { label: "Aktif / Active", cls: "bg-positive-bg text-positive border-positive/30" },
  resigned: { label: "Berhenti / Resigned", cls: "bg-slate/10 text-slate border-slate/30" },
  deceased: { label: "Meninggal / Deceased", cls: "bg-ink/10 text-ink border-ink/30" },
  suspended: { label: "Gantung / Suspended", cls: "bg-brick-bg text-brick border-brick/30" },
  pending: { label: "Menunggu / Pending", cls: "bg-brass/10 text-brass border-brass/30" },
};

export function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.active;
  return (
    <span className={cn("inline-flex items-center border px-2 py-0.5 rounded-sm text-xs font-medium whitespace-nowrap", s.cls)}>
      {s.label}
    </span>
  );
}

const ROLE_MAP = {
  admin: { label: "Super Admin", cls: "bg-brass text-ink" },
  secretariat: { label: "Secretariat", cls: "bg-ink text-paper" },
  member: { label: "Member", cls: "bg-slate/15 text-slate" },
};

export function RoleBadge({ role }) {
  const r = ROLE_MAP[role] || ROLE_MAP.member;
  return <span className={cn("inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-semibold uppercase tracking-wider", r.cls)}>{r.label}</span>;
}

export function RM({ value, className }) {
  const v = typeof value === "number" ? value : 0;
  return (
    <span className={cn("font-mono text-ink tabular-nums", className)}>
      {v.toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
    </span>
  );
}

export function FlagPill({ flag }) {
  const labels = {
    missing_email: "No email",
    missing_mobile: "No mobile",
    missing_ic: "No IC",
    missing_dob: "No DOB",
    missing_join_date: "No join date",
    missing_membership_no: "No membership no",
    missing_no: "No serial",
    unconfirmed_balance: "Balance unconfirmed",
    share_unparseable: "Share garbled",
    share_missing: "Share blank",
  };
  return (
    <span className="inline-flex items-center bg-brick-bg text-brick border border-brick/20 px-1.5 py-0.5 rounded-sm text-[10px] font-medium mr-1 mb-1">
      {labels[flag] || flag}
    </span>
  );
}
